import { render, staticRenderFns } from "./EditTeamName.vue?vue&type=template&id=fb6f334e&scoped=true&"
import script from "./EditTeamName.vue?vue&type=script&lang=js&"
export * from "./EditTeamName.vue?vue&type=script&lang=js&"
import style0 from "./EditTeamName.vue?vue&type=style&index=0&id=fb6f334e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f334e",
  null
  
)

export default component.exports